import { MutationTree } from 'vuex';
import { InterviewRequestState, BasicDetails, InterviewDetails } from './types';

const mutations: MutationTree<InterviewRequestState> = {
  setSitter(state, sitter: any) {
    state.sitter = sitter;
    state.sitterUuid = sitter?.id || null;
  },

  setBasicDetails(state, basicDetails: BasicDetails) {
    state.startTime = basicDetails.startTime;
    state.endTime = basicDetails.endTime;
    state.virtual = basicDetails.virtual;
    state.address = basicDetails.address;
    state.geoPointX = basicDetails.geoPointX;
    state.geoPointY = basicDetails.geoPointY;
  },

  setInterviewDetails(state, interviewDetails: InterviewDetails) {
    state.jobTitle = interviewDetails.jobTitle;
    state.jobUuid = interviewDetails.jobUuid;
    state.careType = interviewDetails.careType;
    state.details = interviewDetails.details;
  },

  setSitterUuid(state, sitterUuid: string) {
    state.sitterUuid = sitterUuid;
  },

  clearAllData(state) {
    state.sitter = null;
    state.sitterUuid = null;
    state.startTime = null;
    state.endTime = null;
    state.virtual = null;
    state.address = null;
    state.geoPointX = null;
    state.geoPointY = null;
    state.jobTitle = null;
    state.jobUuid = null;
    state.careType = null;
    state.details = null;
  },
};

export default mutations;
